import { useTranslation } from 'react-i18next';

export default function Accessories() {
  const { t } = useTranslation('home');
  const accessories = t('accessories.items', { returnObjects: true }) as Array<{
    name: string;
    desc: string;
    tags: string[];
    image: string;
  }>;
  const quoteSteps = t('quoteBox.steps', { returnObjects: true }) as Array<{ num: string; title: string }>;

  return (
    <section id="accessories" className="py-10 md:py-14 bg-slate-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
            <div>
              <div className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">{t('accessories.subtitle')}</div>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900">
                {t('accessories.title')}
              </h2>
            </div>
            <p className="text-sm text-slate-500 max-w-lg">
              {t('accessories.desc')}
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            {/* Accessory cards */}
            <div className="flex-1 space-y-3">
              {accessories.map((item) => (
                <div
                  key={item.name}
                  className="bg-white border border-slate-200 rounded-lg p-4 flex gap-4 hover:border-orange-300 hover:shadow-sm transition-all"
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-20 h-20 object-contain object-center bg-slate-50 rounded-md flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-slate-900 mb-1">{item.name}</h3>
                    <p className="text-xs text-slate-500 leading-relaxed mb-2">{item.desc}</p>
                    <div className="flex flex-wrap gap-2">
                      {item.tags.map((tag) => (
                        <span
                          key={tag}
                          className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Quote box */}
            <div
              id="quote"
              className="lg:w-[360px] bg-slate-900 text-white rounded-lg p-6 flex flex-col justify-between"
            >
              <div>
                <h3 className="text-lg font-bold mb-4">
                  {t('quoteBox.title')}
                </h3>
                <ul className="space-y-3">
                  {quoteSteps.map((step) => (
                    <li key={step.num} className="flex items-start gap-3">
                      <span className="w-6 h-6 bg-white/15 rounded-full flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                        {step.num}
                      </span>
                      <span className="text-sm text-white/90">{step.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="#compare"
                className="mt-6 inline-flex items-center justify-center text-sm font-medium bg-white text-slate-900 px-5 py-2.5 rounded-md hover:bg-slate-100 transition-colors whitespace-nowrap"
              >
                {t('quoteBox.viewFullQuote')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}